import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";
import { MarketLoadType } from "./types";

export const marketLoadApi = {
  getMarketLoad: async () => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/market-loads`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching market load:", error);
      return [];
    }
  },

  createMarketLoad: async (marketLoad: Partial<MarketLoadType>) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/market-loads`;
      const response = await axios.post(url, marketLoad, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      throw new Error(response.data?.message || "Failed to create market load");
    } catch (error) {
      console.error("Error creating market load:", error);
      throw error;
    }
  },

  updateMarketLoad: async (id: string, marketLoad: Partial<MarketLoadType>) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}master-data/market-loads/${id}`;
      const response = await axios.put(url, marketLoad, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      }
      throw new Error(response.data?.message || "Failed to update market load");
    } catch (error) {
      console.error("Error updating market load:", error);
      throw error;
    }
  },

  search: async (searchTerm: string) => {
    try {
      const url = `${
        process.env.REACT_APP_API_HOST
      }master-data/market-loads?search=${encodeURIComponent(searchTerm)}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  },
};
